// @flow

import { type CheckoutReceipts, type Receipt } from './types';

export function getInstalmentsFromReceipts(receipts: CheckoutReceipts): ImmutableArray<Receipt> {
  return ((Object.values(receipts.instalments): any): ImmutableArray<Receipt>);
}

export function getInstalmentByNumber(
  receipts: CheckoutReceipts,
  instalmentNumber: number,
): ?Receipt {
  const instalmentsList = getInstalmentsFromReceipts(receipts);
  return instalmentsList.find(
    ({ instalments_plan }) => instalments_plan && instalments_plan.instalments === instalmentNumber
  );
}

export function getSafeInstalmentByNumber(receipts: CheckoutReceipts, instalmentNumber: number): Receipt {
  const instalment = getInstalmentByNumber(receipts, instalmentNumber);
  if (!instalment)
    throw new Error(`getSafeInstalmentByNumber: there is no instalment number: "${instalmentNumber}"`);
  return instalment;
}
